import React from 'react';
import {useStyles} from './TakisProductDetailHero.styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import TakisPicture from './TakisPicture';
import { useTheme } from "@material-ui/core/styles";
import PropTypes from 'prop-types';
import TakisButton from './TakisButton';

export default function TakisProductDetailHero({heroImageDesktopSrc, heroImageMobileSrc, heroImageTopBackgroundDesktopSrc, heroImageTopBackgroundMobileSrc, heroImageBottomBackgroundSrc, heroImageAlt, title, heroParagraph, firstCta, secondCta, nutritionCta}) {
    const classes = useStyles();
    const theme = useTheme();
    const onDesktop = useMediaQuery(theme.breakpoints.up(theme.breakpoints.values.lg));

    TakisProductDetailHero.propTypes = {
        heroImageDesktopSrc: PropTypes.string.isRequired,
        heroImageMobileSrc: PropTypes.string.isRequired,
        heroImageTopBackgroundDesktopSrc: PropTypes.string.isRequired,
        heroImageTopBackgroundMobileSrc: PropTypes.string.isRequired,
        heroImageBottomBackgroundSrc: PropTypes.string.isRequired,
        heroImageAlt: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        heroParagraph: PropTypes.string.isRequired,
        firstCta: PropTypes.object,
        secondCta: PropTypes.object
    };

    const heroImages = [
      {
        url: heroImageMobileSrc,
        size: "mobile"
      },
      {
        url: heroImageMobileSrc,
        size: "tablet"
      },
      {
        url: heroImageDesktopSrc,
        size: "desktop"
      }
    ];

    const backgroundImages = [
      {
        url: heroImageTopBackgroundMobileSrc,
        size: "mobile"
      },
      {
        url: heroImageTopBackgroundMobileSrc,
        size: "tablet"
      },
      {
        url: heroImageTopBackgroundDesktopSrc,
        size: "desktop"
      }
    ];

    const bottomBackgroundImages = [
      {
        url: heroImageBottomBackgroundSrc,
        size: "mobile"
      },
      {
        url: heroImageBottomBackgroundSrc,
        size: "tablet"
      },
      {
        url: heroImageBottomBackgroundSrc,
        size: "desktop"
      }
    ];

    return (
      <>
      <div className={`${classes.productDetailHero}`}>
        <div className={classes.backgroundContainer}>
          <TakisPicture
            pictureClass={classes.backgroundImage}
            images={backgroundImages}
            isLazy={false}
            altText={`${title} background`}
          />
        </div>
        <div className={`${classes.productDetailHeroCenter}`}>
          <div className={classes.productDetailContainer}>
            <div className={classes.productDetailColumn}>
              <TakisPicture
                pictureClass={classes.heroImage}
                images={heroImages}
                isLazy={false}
                altText={heroImageAlt}
              />
            </div>
            <div className={classes.productDetailColumn}>
              <div className={classes.productDetailContent}>
                <div className={classes.titleContainer}>
                  <h1 className={classes.title}>
                    {title}
                  </h1>
                </div>
                <div
                  className={classes.paragraph}
                  dangerouslySetInnerHTML={{__html: heroParagraph}}
                />
                { firstCta.imageContent ?
                  <div className={classes.paragraph}><p>{firstCta.title}</p></div>
                  : <></>
                }
                <div className={classes.ctasContainer}>
                  {firstCta && firstCta.title &&
                  <TakisButton
                    title={firstCta.title}
                    alt={firstCta.alt}
                    href={firstCta.href}
                    ariaLabel={firstCta.ariaLabel}
                    color="purpleButton"
                    orientation={firstCta.orientation}
                    imageContent={firstCta.imageContent}
                  >
                  </TakisButton>}
                  {secondCta && secondCta.title && <TakisButton
                    title={secondCta.title}
                    alt={secondCta.alt}
                    href={secondCta.href}
                    ariaLabel={secondCta.ariaLabel}
                    color="purpleButton"
                    orientation={secondCta.orientation}
                  />}
                </div>
              </div>
              <div className={`${onDesktop ? classes.hidden : ""}`}>
                <TakisPicture
                  pictureClass={classes.bottomBackgroundImage}
                  images={bottomBackgroundImages}
                  isLazy={false}
                  altText={`${title} background`}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.nutrition_div}>
        {nutritionCta && nutritionCta.title && <TakisButton
          title={nutritionCta.title}
          alt={nutritionCta.alt}
          href={nutritionCta.href}
          ariaLabel={nutritionCta.ariaLabel}
          color="fullPurpleButton"
        />}
      </div>
      </>
  );
}
